// The signed-in user's role, for the interface only: buttons a role cannot use
// are disabled with the reason. The backend enforces every right on its own.
import { api } from "./api/client";
import { useResource } from "./api/resource";
import type { CurrentUser } from "./api/types";

const LEVEL: Record<CurrentUser["user"]["role"], number> = { preparer: 1, reviewer: 2, approver: 3, admin: 4 };

export function useCurrentUser() {
  const me = useResource("auth:me", () => api.me());
  const data = me.data;
  /** True when the user may act with `role`; always true without sign-in (SFCR_AUTH_MODE=off). */
  const can = (role: CurrentUser["user"]["role"]) => !data || data.mode === "off" || LEVEL[data.user.role] >= LEVEL[role];
  return { me: data, can, local: data?.mode === "local" };
}
